import { ReactComponent as ChevronRight } from '../../../../assets/icons/chevronRight.svg';
import { useState } from "react";
import {ReactComponent as Deposit} from "../../../../assets/icons/deposit.svg";

const Transferencia = ({paymentProvider, setPaymentProvider}) => {
  const expandAndSetPaymentProvider = () => {
    if (paymentProvider !== "bank") {
        setPaymentProvider("bank");
    } else {
        setPaymentProvider("")
    }
  }

  return (
    <div className={`payments-dropdown__container ${paymentProvider === "bank" ? ' selected' : ''}`}>
    <button
      className={`payments-dropdown__button ${paymentProvider === "bank" ? ' selected' : ''}`}
      onClick={expandAndSetPaymentProvider}
    >
      <div className="payments-dropdown__button-elements">
        <span className="icon">
          <Deposit/>
        </span>
        <span>
          Depósito bancario o Efectivo
        </span>
      </div>
      <div className={paymentProvider === "bank" ? "dropdown__icon dropdown__icon--expanded" : "dropdown__icon"}>
        <ChevronRight/>
      </div>
    </button>
    <form className={`payments-dropdown__form${paymentProvider === "bank" ? ' expanded' : ''}`}>
        <div className="payments-dropdown__form-content">
            Al finalizar la compra verás la información para realizar el pago.
        </div>
      </form>
  </div>
  )
};
export default Transferencia;
